<ng-template appMarketingMenuHeaderInflatorContainer></ng-template>
